import { PagebuilderContext } from 'react-pagebuilder/services/pagebuilderContext'
import { ToolbarItem } from './ToolbarItem'
import { ToolbarSection } from './ToolbarSection'
import { useContext } from 'react'
import { getIcon } from '@utils/icons'
import { Menu, Pin } from '@components/icons'

export type PagebuilderCtaItemType = {
  style?: string
  ctaLabel?: string
  url?: string
  blank?: boolean
  anchor?: string
}

export const ctaDefaultProps = (ctaLabel = null, icon = null, iconPos = null) => ({
  ...(icon !== null ? { icon: icon } : {}),
  ...(iconPos !== null ? { iconPos: iconPos } : {}),
  ...(ctaLabel !== null ? { ctaLabel: ctaLabel } : {}),
  url: null,
  extUrl: '',
  blank: false,
  anchor: '',
})

export const ctaItemParams: (props?: any, enabled?: boolean) => PagebuilderCtaItemType = (
  props,
  enabled
) => ({
  ...(Object.keys(props).includes('icon') ? { icon: getIcon(props.icon) } : {}),
  ...(Object.keys(props).includes('iconPos') ? { iconPos: props.iconPos } : {}),
  ...(Object.keys(props).includes('ctaLabel') ? { ctaLabel: props.ctaLabel } : {}),
  url: enabled
    ? props.url || props.extUrl || props.anchor
      ? '#'
      : ''
    : props.url || props.extUrl || props.anchor
    ? (props.url ? props.url : props.extUrl) + (props.anchor ? `#${props.anchor}` : '')
    : '',
  blank: enabled ? false : props.blank,
})

const CtaToolbarSection = ({ defaultProps, initOpen = false }) => {
  const { urlOpts } = useContext(PagebuilderContext)

  return (
    <ToolbarSection title="Call to action" initOpen={initOpen}>
      {Object.keys(defaultProps).includes('icon') && (
        <ToolbarItem
          propKey="block"
          propSubKey="icon"
          type="icon"
          label="Icona"
          defaultValue={defaultProps['icon']}
        />
      )}
      {'ctaLabel' in defaultProps && (
        <ToolbarItem
          propKey="block"
          propSubKey="ctaLabel"
          type="text"
          label="Label"
          defaultValue={defaultProps['ctaLabel']}
        />
      )}
      <ToolbarItem
        propKey="block"
        propSubKey="extUrl"
        type="text"
        label="URL"
        defaultValue={defaultProps['extUrl']}
      />
      {urlOpts && (
        <ToolbarItem
          propKey="block"
          propSubKey="url"
          type="select"
          label="Page Link"
          options={urlOpts}
          nullable
          defaultValue={defaultProps['url']}
        />
      )}
      <ToolbarItem
        propKey="block"
        propSubKey="anchor"
        type="text"
        label="Anchor"
        defaultValue={defaultProps['anchor']}
      />
      <ToolbarItem
        propKey="block"
        propSubKey="blank"
        type="switch"
        label="Apri in nuova finestra"
        defaultValue={defaultProps['blank']}
      />
    </ToolbarSection>
  )
}

export default CtaToolbarSection
